﻿import * as React from "react";
import "./Tabs.scss";
import { Tabs as MuiTabs, Tab as MuiTab, TabsProps, TabProps } from "@mui/material";
import { getDataProps, type WithDataProps } from "../../shared/utilities";


interface TabsContainerProps extends React.ComponentProps<any> {
}

const TabsContainer: React.FunctionComponent<TabsContainerProps> = (props: TabsContainerProps) => {
    const { children, ...rest } = props;

    return (
        <div className="tabs-container" {...rest}>
            {children}
        </div>
    );
}

interface TabPanelProps {
    value?: any;
    selectedValue?: any;
    className?: string;
    children?: any;
}


const TabPanel: React.FunctionComponent<TabPanelProps> = (props: TabPanelProps) => {
    const { value, selectedValue, children } = props;
    const isVisible = value === selectedValue;

    return (
        isVisible &&
        <div className="tabpanel">
            {children}
        </div>
    );
}

const PersistentTabPanel: React.FunctionComponent<TabPanelProps> = (props: TabPanelProps) => {
    const { value, selectedValue, className, children, ...other } = props;
    const isVisible = value === selectedValue;

    return (
        <div {...other} className={`tabpanel ${isVisible ? "" : "tabpanel-hidden"}`}>
            {children}
        </div>
    );
}

const Tabs: React.FunctionComponent<WithDataProps<TabsProps>> = (props: WithDataProps<TabsProps>) => {

    return (
        <MuiTabs variant="scrollable" {...props} {...getDataProps(props)} />
    );
}

const Tab: React.FunctionComponent<WithDataProps<TabProps>> = (props: WithDataProps<TabProps>) => {

    return (
        <MuiTab {...props} {...getDataProps(props)}  />
    );
}

export { TabsContainer, TabPanel, PersistentTabPanel, Tabs, Tab };
export type { TabPanelProps, TabsProps, TabProps };